<span [ngClass]="['custom-tag', size, color]">
  {{ label }}
</span>
